import { createStore } from 'vuex'

import microsite from './microsite'
import fieldData from './field-data'
import orderForm from './order-form'
import manageCoverage from './manage-coverage'

const store = createStore({
  modules: {
    microsite,
    fieldData,
    orderForm,
    manageCoverage
  }
})

export default store
